var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEficiencia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.10579 3.00438C2.62804 2.45671 3.17582 53.4001 8.10579 53.4C13.0358 53.3999 50.8325 32.5843 50.8325 28.2022C50.8325 23.82 13.5835 3.55206 8.10579 3.00438Z",
    fill: "#E9EFF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2328 25.9595C23.6297 30.7267 17.2734 30.7267 17.2734 30.7267C17.2734 30.7267 17.2734 24.3705 22.0406 22.7673",
    stroke: "url(#paint0_linear_5_109)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5484 14.8219L30 24.3703L23.6296 18L33.1781 8.45158C36.7921 4.83752 40.4062 4.8797 41.9531 5.1047C42.1918 5.13655 42.4134 5.24606 42.5836 5.41634C42.7539 5.58662 42.8634 5.8082 42.8953 6.04689C43.1203 7.59377 43.1625 11.2078 39.5484 14.8219Z",
    stroke: "url(#paint1_linear_5_109)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9594 16.4109V25.4953C37.9551 25.792 37.8338 26.0751 37.6219 26.2828L33.0797 30.839C32.9356 30.983 32.7551 31.0851 32.5575 31.1345C32.3599 31.1839 32.1526 31.1787 31.9577 31.1195C31.7628 31.0603 31.5877 30.9493 31.4509 30.7984C31.3142 30.6475 31.221 30.4622 31.1812 30.2625L30 24.3703",
    stroke: "url(#paint2_linear_5_109)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.589 10.0408H22.5046C22.2078 10.045 21.9248 10.1663 21.7171 10.3783L17.1608 14.9205C17.0169 15.0646 16.9148 15.245 16.8654 15.4426C16.816 15.6402 16.8211 15.8475 16.8803 16.0424C16.9395 16.2373 17.0505 16.4125 17.2015 16.5492C17.3524 16.686 17.5376 16.7792 17.7374 16.8189L23.6296 18.0001",
    stroke: "url(#paint3_linear_5_109)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_109",
    x1: 17.2734,
    y1: 26.747,
    x2: 25.2328,
    y2: 26.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28AFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56CFCE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5_109",
    x1: 23.6296,
    y1: 14.6948,
    x2: 42.9807,
    y2: 14.6948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28AFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56CFCE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5_109",
    x1: 30,
    y1: 23.7895,
    x2: 37.9594,
    y2: 23.7895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28AFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56CFCE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5_109",
    x1: 16.8318,
    y1: 14.0205,
    x2: 31.589,
    y2: 14.0205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28AFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56CFCE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEficiencia);
export default __webpack_public_path__ + "static/media/icon-eficiencia.a91ebc3da508747f60c2117ab4a5ab91.svg";
export { ForwardRef as ReactComponent };